function isScrolledIntoView(elem){
    var docViewTop = jQuery(window).scrollTop();
    var docViewBottom = docViewTop - 100 + jQuery(window).height();

    var elemTop = jQuery(elem).offset().top;
    var elemBottom = elemTop + jQuery(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
console.log(elemTop + ' ' + elemBottom);
}

function changeOpacity(){
    jQuery(".moreInfo").each(function(){
        var gallery = jQuery(this);
        if (isScrolledIntoView(this)){
            gallery.css("background","url(https://cdn.shopify.com/s/files/1/0254/6845/t/9/assets/moo2.png) center no-repeat #dbc59b");
gallery.css("background-size","40px");
        }
        else{
            gallery.css("background","url(https://cdn.shopify.com/s/files/1/0254/6845/t/9/assets/moo.png) center no-repeat #dbc59b");
gallery.css("background-size","40px");
        }
    });
}

jQuery(function(){
    changeOpacity();
    jQuery(window).scroll(changeOpacity);
});